import { QueryHookOptions, gql, useQuery } from '@apollo/client';
import { RetrieveCheckoutQuery, RetrieveCheckoutQueryVariables } from '../../graphql/types';
import { client } from '../../lib/apollo';

const RETRIEVE_CHECKOUT = gql`
  query RetrieveCheckout($checkoutSessionId: String!) {
    retrieveCheckout(checkoutSessionId: $checkoutSessionId) {
      email
      activated
      plan
      emailHasMatchingAccount
      amountTotal
      userId
      paymentIntentId
      invoiceId
      paymentCompleted
    }
  }
`;

export const useRetrieveCheckout = (
  options: QueryHookOptions<RetrieveCheckoutQuery, RetrieveCheckoutQueryVariables>,
) => useQuery<RetrieveCheckoutQuery, RetrieveCheckoutQueryVariables>(RETRIEVE_CHECKOUT, options);

export const retrieveCheckout = (checkoutSessionId: string) =>
  client.query<RetrieveCheckoutQuery, RetrieveCheckoutQueryVariables>({
    query: RETRIEVE_CHECKOUT,
    variables: { checkoutSessionId },
    fetchPolicy: 'network-only',
  });
